import React from "react";

export const Stripe = ({ Stripe }) => {
  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-6 rounded-xl">
      <p className="opacity-60 md:w-3/4">
        Each sale will incur a 25% fee. This feature is available in all
        countries where Stripe operates, except Brazil, India, Indonesia,
        Malaysia, Mexico, Philippines, and Thailand.
      </p>

      <div
        className={
          "bg-[#635BFF] text-white w-fit flex items-center space-x-2 mt-3 px-4 py-3 rounded-xl "
        }
      >
        <img src={Stripe} alt="" />
        <p>Connect with Stripe</p>
      </div>
    </div>
  );
};
